module.exports = __webpack_public_path__ + "static/media/Liri.07909572.gif";